import clsx from 'clsx'
import React from 'react'
import Loader from "react-loader-spinner";

const OutlineButton = ({ loading, className, disabled, children, ...rest }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      {...rest}
      className={clsx("w-72 h-12 mx-auto capitalize text-yellow-primary bg-transparent focus:ring-0 rounded-full text-lg px-5 focus:outline-none font-bold border-4 border-yellow-primary", disabled && 'opacity-60', !disabled && 'hover:border-yellow-secondary', className)}
    >
      {loading ? (
        <Loader
          type="Oval"
          visible={true}
          color="#ffe000"
          width={24}
          height={24}
          className="flex flex-1 justify-center items-center"
        />
      ) : children}
    </button>
  )
}

export default OutlineButton
